import {
  ArchiveBoxIcon,
  InboxIcon,
  BuildingStorefrontIcon,
  CalendarIcon,
  ListBulletIcon,
  PrinterIcon,
  ScaleIcon,
  ShoppingCartIcon,
  TruckIcon,
} from "@heroicons/vue/24/outline/index";
import { useNotifications } from "~/stores/notifications.js";
import { useNuxtApp } from "#app";

export const useMenu = () => {
  const notify = useNotifications();
  const { $api, $i18n } = useNuxtApp();

  return [
    {
      id: "tables",
      text: $i18n.t("Tables"),
      icon: BuildingStorefrontIcon,
      to: "/tables",
      match: null,
    },
    {
      id: "takeaway",
      text: $i18n.t("Takeaway"),
      icon: TruckIcon,
      to: "/takeaway-orders",
      match: null,
    },
    {
      id: "reservations",
      text: $i18n.t("Reservations"),
      icon: CalendarIcon,
      to: "/reservations",
      match: null,
    },
    {
      id: "checkout",
      text: $i18n.t("Checkout"),
      icon: ShoppingCartIcon,
      to: "/orders/create",
      match: null,
    },
    {
      id: "orders",
      text: $i18n.t("Orders"),
      icon: ListBulletIcon,
      to: "/orders",
      match: (path) => path !== "/orders/create" && path.startsWith("/orders"),
    },
    {
      id: "stock",
      text: $i18n.t("Stock"),
      icon: ArchiveBoxIcon,
      to: "/stock",
      match: null,
    },
    {
      id: "print-jobs",
      text: $i18n.t("Print Jobs"),
      icon: PrinterIcon,
      to: "/print-jobs",
      match: null,
    },
    {
      id: "settle",
      text: $i18n.t("Settlement"),
      icon: ScaleIcon,
      to: "/settlement",
      match: null,
    },
    {
      id: "open-cash-box",
      text: $i18n.t("Open cash box"),
      icon: InboxIcon,
      match: null,
      onClick: async () => {
        await $api("/cash-box-openings", {
          method: "POST",
        });

        notify.success($i18n.t("Cash box opened"));
      },
    },
  ];
};
